module.exports = __webpack_public_path__ + "static/unknown-349c2954e5dc78caa1d392d62782fd89.png";